import { BaseMethodReturnType } from 'src/types/commonTypes';
import { IConnectionInfoSubsystemStrategy, EventData } from '../types';
import type {
  EventInfo,
  SubscriptionHandle
} from '@clientos/commons-northbound-api/dist/services/JWeb/types';
import { DEVICE_CONNECTIVITY_CHANGED_EVENT_NAME } from 'src/consts';

export default class JWebConnectionInfoStrategy
  implements IConnectionInfoSubsystemStrategy
{
  async hasInternetAccess(): Promise<BaseMethodReturnType<boolean>> {
    const deviceInfo = await (window as any)?.JWeb?.Plugins?.Device?.getInfo();
    return {
      result: deviceInfo.isInternetConnected === 'true'
    };
  }

  async listenHasInternetAccess(
    callback: (hasInternetAccess: boolean) => void
  ): Promise<BaseMethodReturnType<{ remove: () => void }>> {
    const EventService = (window as any)?.JWeb.Plugins.EventService;
    const subscriber = await EventService?.createSubscriber();
    const subscription = (await subscriber.subscribe(
      {
        eventName: DEVICE_CONNECTIVITY_CHANGED_EVENT_NAME
      },
      (eventInfo: EventInfo) => {
        const eventData = eventInfo?.eventData as EventData;
        callback(eventData?.isInternetConnected);
      }
    )) as SubscriptionHandle;

    const remove = () => subscription.unsubscribe();

    return {
      result: { remove }
    };
  }
}
